import { Directive, ElementRef, EventEmitter, HostListener, Output, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[literaxUppercaseInput]',
})
export class LiteraxUppercaseInputDirective {
  @Output() valueUppercased = new EventEmitter<string>();

  constructor(
    private readonly ngControl: NgControl,
    private readonly el: ElementRef<HTMLInputElement>,
    private readonly renderer: Renderer2
  ) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const upper = (event.target as HTMLInputElement).value.toUpperCase();

    this.ngControl.control.setValue(upper);
    this.renderer.setProperty(this.el.nativeElement, 'value', upper);

    this.valueUppercased.emit(upper);
  }
}
